// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2oIoe","box":"WorkspacesBox_box__wYEHU","node":"WorkspacesBox_node__2-cNE"};